import React, {Fragment} from 'react'
import {useParams, useHistory} from 'react-router-dom'
import useGroup from 'admin/hooks/useGroup'
import useDocument from 'admin/hooks/useDocument'
import useStateObject from 'admin/hooks/useStateObject'
import useEffect from 'admin/hooks/useEffect'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'
import useBoolState from '../../hooks/useBoolState'
import Deletion from '../Deletion'
import useModal from '../../hooks/useModal'
import ColorPickerField from '../shared/ColorPickerField'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const {groupId, type, popModal} = useModal()
  const {errors, group, update, destroy} = useGroup(organisationID, type, groupId)
  const [form, setForm, resetForm] = useStateObject(group)
  const [showConfirmDelete, setConfirmDelete, toggleConfirmDelete] = useBoolState()
  useDocument({title: `Group ${groupId}`})

  useEffect(() => setForm(group), [group])

  const handleUpdate = e => {
    e.preventDefault()
    update(form)
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(group)
    popModal('group', ['groupId', 'type'])
  }

  return (
    <Fragment>
      <Modal onClose={handleClose} flashId='group' minWidth='50%'>
        <Header title={`Edit ${group.name}`}>
          <button className='button is-danger is-outlined' onClick={toggleConfirmDelete}>
            Delete
          </button>
          <button className='button is-primary' onClick={handleUpdate}>
            Save
          </button>
        </Header>
        <section className='section'>
          <div className='container'>
            <form>
              <div className='field is-grouped'>
                <div className='control is-expanded'>
                  <InputField
                    type='text'
                    name='name'
                    autoComplete='off'
                    value={form.name || ''}
                    errors={errors.name}
                    onChange={setForm}
                  />
                </div>
                <div className='control'>
                  <label htmlFor='colour' className='label is-small'>
                    Colour
                  </label>
                  <ColorPickerField name='colour' value={form.colour || ''} onChange={setForm} />
                </div>
              </div>
            </form>
          </div>
        </section>
      </Modal>

      {showConfirmDelete && (
        <Deletion
          confirm='Are you sure you want to delete?'
          onConfirm={() => destroy({}, history.goBack)}
          onClose={toggleConfirmDelete}
        />
      )}
    </Fragment>
  )
}
